import { render, staticRenderFns } from "./CAIG0040BeforeLogin.vue?vue&type=template&id=21d69674"
import script from "./CAIG0040Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAIG0040Controller.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports